import React from 'react'
import { Carousel } from 'react-responsive-carousel'

import shush from '../images/shush.jpg'
import valuerocker from '../images/valuerocker.jpg'
import purgapalooza2 from '../images/purgapalooza2.jpg'
import fiftyfifty from '../images/5050.jpg'
import opshop from '../images/opshop17.jpg'
import solidgold from '../images/solidgold.jpg'

let imgUrls = [
  'https://www.redbubble.com/people/jradvan/works/30499628-please-stop-shush-tapestry?asc=u&p=sticker',
  'https://www.redbubble.com/people/jradvan/works/31334044-please-stop-value-rocker-pedal?asc=u&p=t-shirt',
  'https://www.redbubble.com/people/jradvan/works/30496558-please-stop-purgapalooza-ii-28-apr-2018?asc=u&p=sticker',
  'https://www.redbubble.com/people/jradvan/works/32824781-please-stop-50-50?asc=u&p=sticker',
  'https://www.redbubble.com/people/jradvan/works/32931130-op-shop-trivia-2017-gig-sticker?asc=u&p=sticker',
  'https://www.redbubble.com/people/jradvan/works/32955590-solid-gold-disco-2018-gig-sticker?asc=u&p=sticker'
]

function imgClickHandler(index, element) {
  window.open(imgUrls[index], '_blank');
}

export default () => (
  <Carousel autoPlay dynamicHeight={true} infiniteLoop={true} interval={5000} centerMode={true} useKeyboardArrows={true} showStatus={false} onClickItem={imgClickHandler}>
    <div>
      <img src={shush} />
    </div>
    <div>
      <img src={valuerocker} />
    </div>
    <div>
      <img src={purgapalooza2} />
    </div>
    <div>
      <img src={fiftyfifty} />
    </div>
    <div>
      <img src={opshop} />
    </div>
    <div>
      <img src={solidgold} />
    </div>
  </Carousel>
);



// WEBPACK FOOTER //
// ./src/components/Carousel.js